<template>
  <span
    class="ct-btn"
    @click="handleBtnClick"
    :class="{
      'ct-btn-default': !type,
      'ct-btn-primary': type === PRIMARY,
      'ct-btn-standard': size === STANDARD,
      'ct-btn-small': size === SMALL
    }"
  >
    <slot></slot>
  </span>
</template>

<script>
const PRIMARY = 'primary';
const STANDARD = 'standard';
const SMALL = 'small';
export default {
  data() {
    return {
      PRIMARY,
      STANDARD,
      SMALL
    };
  },
  props: {
    type: {
      type: String,
      default: ''
    },
    size: {
      type: String,
      default: STANDARD
    },
    btnClick: {
      type: Function,
      default: function() {}
    }
  },
  methods: {
    handleBtnClick() {
      this.btnClick();
    }
  }
};
</script>

<style lang="less">
.ct-btn {
  font-size: 14px;
  font-weight: bold;
  box-sizing: border-box;
  color: @white-color;
  text-align: center;
  cursor: pointer;
  position: relative;
  &::before {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 100%;
    height: 100%;
    background-color: #000;
    border: inherit;
    border-color: #000;
    border-radius: inherit;
    transform: translate(-50%, -50%);
    opacity: 0;
    content: ' ';
  }
}
.ct-btn-default {
  background: #fff;
  border: 1px solid #dcdfe6;
  color: #606266;
}
.ct-btn-primary {
  background: linear-gradient(to right, #0878bf, #0056aa);
}

.ct-btn-standard {
  min-width: 105px;
  height: 32px;
  line-height: 32px;
  border-radius: 8px;
  display: inline-block;
}
.ct-btn-small {
  padding: 9px 15px;
  font-size: 12px;
  border-radius: 3px;
}

.ct-btn:active::before {
  opacity: 0.3;
}
</style>
